<h2 mat-dialog-title>
    {{ 'ECMR.template_overview.load_from_template_header' | translate }}
</h2>
<mat-dialog-content>
    <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z3 w-100 mt-1">
        <ng-container matColumnDef="number">
            <th
                mat-header-cell
                *matHeaderCellDef>
                {{ 'ECMR.template_overview.table_header.number' | translate }}
            </th>
            <td
                mat-cell
                *matCellDef="let element">
                {{ element.templateUserNumber }}
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th
                mat-header-cell
                *matHeaderCellDef>
                {{ 'ECMR.template_overview.table_header.name' | translate }}
            </th>
            <td
                mat-cell
                *matCellDef="let element">
                {{ element.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="refId">
            <th
                mat-header-cell
                *matHeaderCellDef>
                {{ 'ECMR.overview.table_header.ref_id' | translate }}
            </th>
            <td
                mat-cell
                *matCellDef="let element">
                {{
                    element.ecmr.ecmrConsignment.referenceIdentificationNumber
                        .value
                }}
            </td>
        </ng-container>

        <ng-container matColumnDef="from">
            <th
                mat-header-cell
                *matHeaderCellDef>
                {{ 'ECMR.overview.table_header.from' | translate }}
            </th>
            <td
                mat-cell
                *matCellDef="let element">
                {{
                    element.ecmr.ecmrConsignment.senderInformation
                        .senderCompanyName
                }}
            </td>
        </ng-container>

        <ng-container matColumnDef="to">
            <th
                mat-header-cell
                *matHeaderCellDef>
                {{ 'ECMR.overview.table_header.to' | translate }}
            </th>
            <td
                mat-cell
                *matCellDef="let element">
                {{
                    element.ecmr.ecmrConsignment.consigneeInformation
                        .consigneeCompanyName
                }}
            </td>
        </ng-container>

        <tr
            mat-header-row
            *matHeaderRowDef="columnsToDisplay"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: columnsToDisplay"
            (click)="selectedTemplate = row"
            [class.highlight]="selectedTemplate === row"></tr>
    </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-flat-button
        color="warn"
        (click)="closeDialog()">
        {{ 'ECMR.common.cancel' | translate }}
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
    <button
        mat-flat-button
        color="primary"
        [disabled]="!selectedTemplate"
        (click)="loadSelectedTemplate()">
        {{ 'ECMR.template_overview.load_selected' | translate }}
        <mat-icon fontSet="material-symbols-outlined">upload_file</mat-icon>
    </button>
</mat-dialog-actions>
